import * as type from './helpPopupsActionTypes';

// Help Popups actions
export const disableQuestion = (questionId, chapterId) => ({
  type: type.DISABLE_QUESTION,
  questionId,
  chapterId,
});

export const disableQuestionError = (error) => ({
  type: type.DISABLE_QUESTION_ERROR,
  error,
});

export const disableQuestionLoading = (isLoading) => ({
  type: type.DISABLE_QUESTION_LOADING,
  isLoading,
});

export const disableQuestionSuccess = (success) => ({
  type: type.DISABLE_QUESTION_SUCCESS,
  success,
});

export const disableQuestionResponse = (response) => ({
  type: type.DISABLE_QUESTION_SUCCESS,
  response,
});

export const reportQuestion = (questionId, payload) => ({
  type: type.REPORT_QUESTION,
  questionId,
  payload,
});

export const reportQuestionError = (error) => ({
  type: type.REPORT_QUESTION_ERROR,
  error,
});

export const reportQuestionLoading = (isLoading) => ({
  type: type.REPORT_QUESTION_LOADING,
  isLoading,
});

export const reportQuestionSuccess = (success) => ({
  type: type.REPORT_QUESTION_SUCCESS,
  success,
});
